'use strict';
/**
 * @module NavigationHandler
 * @description Handles the navigation menu and its dropdowns. Used in sidebar navigation.
 */
const $ = require('jquery');

const tabletBreakpoint = 1280;
const mobileBreakpoint = 768;
const menuToggledClass = 'mobile-menu-toggled';
const noScrollClass = 'no-scroll-mobile';
const navBackgroundClass = 'nav-background-white';
const openClass = 'open';
const hideClass = 'hide';
let hoverEffect = false; //disabled for now

let mobileThreshold = window.matchMedia('(max-width: ' + (mobileBreakpoint - 1) + 'px)'); //checking if mobile
let tabletThreshold = window.matchMedia('(max-width: ' + (tabletBreakpoint - 1) + 'px)'); //checking if tablet
let isTablet = tabletThreshold.matches;
let isMobile = mobileThreshold.matches;
let $navigationToggle;
let $tabletWrapper; //wrapper
let $mobileWrapper; //wrapper
let $navigationLink; //individual links
let $mainNavigation;

const backgroundChangePos = 125;

class NavigationHandler {

  constructor() {
    $mainNavigation = $('.site-navigation')[0];
    $navigationToggle = $('.toggle-button')[0];
    $tabletWrapper = $('.main-navigation-dropdowns')[0];
    $mobileWrapper = $('.navigation-link-wrapper')[0];
    $navigationLink = $('.navigation-link');

    [mobileThreshold, tabletThreshold].forEach((threshold) => {
      threshold.onchange = this._handleScreenChange;
    });


    //this._checkScroll();
    //this._addScrollHandlers();

    //this._toggleMenu();
    //this._hideMobileMenu();
    //this._mainNavigationDropdowns();
    this._sideNavigationDropdowns();
  }

  /**
   * Initialize navigation
   *
   * @memberof NavigationHandler
   * @returns {void}
   * @public
   */
  init() {
    this._handleScreenChange();
  }

  /**
   * Hides mobile menu when link is clicked
   */
  _hideMobileMenu() {
    for (let $link of $navigationLink) {
      $($link).on('click', (event) => {
        $($mobileWrapper).removeClass(menuToggledClass);
        $($tabletWrapper).removeClass(menuToggledClass);
        $('body').removeClass(noScrollClass);
      });
    }
  }

  /**
   * Aligns the menu state with the predifined thresholds (mobile, tablet, desktop)
   */
  _handleScreenChange() {
    $('body').removeClass(noScrollClass);
    if (tabletThreshold.matches && mobileThreshold.matches) {
      isTablet = isMobile = true;
      $($tabletWrapper).removeClass(menuToggledClass);
    } else if (tabletThreshold.matches) {
      isTablet = true;
      isMobile = false;
      $($mobileWrapper).removeClass(menuToggledClass)
    } else {
      isTablet = isMobile = false;
      $($tabletWrapper, $mobileWrapper).removeClass(menuToggledClass);
    }
  }


  /**
   * Toggles mobile menu
   */
  _toggleMenu() {
    $($navigationToggle).on('click', (event) => {

      if (isMobile || isTablet) {
        $('body').toggleClass(noScrollClass);
        $($mobileWrapper).toggleClass(menuToggledClass);
      }

      // if (!isMobile && isTablet) {
      //   $('body').toggleClass(noScrollClass);
      //   $($tabletWrapper).toggleClass(menuToggledClass);
      // }

      //open the current page menu tree
      $('.main-navigation-dropdowns .current').parents('.navigation__dropdown').addClass(openClass);
    });
  }

  /**
   * Used for navigation transparency
   */
  _checkScroll() {
    const scrollPos = $(window).scrollTop();

    if (scrollPos >= backgroundChangePos && !$($mainNavigation).hasClass(navBackgroundClass)) {
      $($mainNavigation).addClass(navBackgroundClass);
    } else if (scrollPos < backgroundChangePos) {
      $($mainNavigation).removeClass(navBackgroundClass);
    }
  }

  /**
   * Adds scroll detection for navigation transparency css
   */
  _addScrollHandlers() {
    $(window).scroll(() => { this._checkScroll(); });
  }

  /**
   * Open or close dropdown
   * @param {JQuery} $element dropdown parent
   * @param {JQuery} $button button/buttons that activates dropdown
   */
  _toggleOpen($element, $button) {
    if (!$element.hasClass(openClass)) {
      $element.addClass(openClass);
      $button.attr('aria-expanded', 'true');
    } else {
      this._closeDropdown($element);
    }
  }


  /**
   * Open or close dropdown
   * @param {JQuery} $element dropdown/dropdowns parent
   */
  _closeDropdown($element) {
    $element.removeClass(openClass);

    //set aria-expanded close to all but active and parent
    $element.each(function() {
      $( this ).find('button').first().attr('aria-expanded', 'false');
    });

  }


  _toggleTabindex($navItem, $dropDownItem) {

    const $dropdownLinks = $dropDownItem.find('a');

    if ($navItem.hasClass(openClass)) {
      $dropdownLinks.attr('tabindex', 0);
    } else {
      $dropdownLinks.attr('tabindex', -1);
    }
  }

  /**
   * Toggle level-2 navigation view
   * @param {JQuery} $sideNavItems sidenav items
   */
  _toggleSideNavView($sideNavItems) {
    const width = window.innerWidth;

    if (width >= tabletBreakpoint) {
      $sideNavItems.removeClass(hideClass);
    } else {
      $sideNavItems.addClass(hideClass);
    }
  }

  /**
   *  toggle main navigation dropdowns
   */
  _mainNavigationDropdowns() {
    if ($('.main-navigation-dropdowns').length) {
      let self = this;
      const $dropdownContainers = $('.main-navigation-dropdowns .navigation__item--link-container');

      //we need hover ONLY on the first level dropdowns
      const $mainDropdowns = $('.main-navigation-dropdowns .level-1 > .navigation__item > .navigation__item--link-container');

      hoverEffect = $mainDropdowns.length ? true : false;

      //hover
      if(hoverEffect){
        $mainDropdowns.on('mouseover', function (e) {
          //prevent icon elements activating dropdown event
          if ($(e.target).is('a')) {
            self._dropdownEvent($(this));
          }
        });
      }

      //click
      $dropdownContainers.on('click', function (e) {
        if ($(e.target).not('a')) {
          self._dropdownEvent($(this));
        }
      });

      //close menus on body click
      $('body').on('click', (e) => {
        //only on desktop
        if (!isTablet && !isMobile) {
          const elementInNav = $(e.target).closest('.navigation__item').length > 0;

          if (!elementInNav) {
            self._closeDropdown($('.navigation__item'));
          }
        }
      });

    }
  }


  /**
   *  toggle side navigation elements
   */
  _sideNavigationDropdowns() {
    if ($('.side-nav').length) {

      let self = this;

      //open the current page menu
      $('.side-nav .current').parents('.navigation__dropdown').addClass(openClass);

      const $rootNavigation = $('.side-nav .level-1');
      if (isTablet || isMobile) {
        //on mobile or tablet, add needed classes to activate first level dropdown functions
        $rootNavigation.children('div').first().addClass('navigation__item');
        const $rootNavigationDropDown = $rootNavigation.find('.first').first();
        $rootNavigationDropDown.addClass('navigation__item--link-container');
      }

      //hide and show sidenav items desktop vs tablet/mobile
      const $sideNavItems = $rootNavigation.find('.level-2');
      //first load toggle
      self._toggleSideNavView($sideNavItems);
      window.addEventListener('resize', function () {
        self._toggleSideNavView($sideNavItems);
      });

      const $dropdownContainer = $('.side-nav .navigation__item--link-container');

      //click icon
      $dropdownContainer.on('click', function (e) {
        if ($(e.target).not('a')) {
          //toggle self menu
          self._dropdownEvent($(this));
        }
      });

    }
  }


  /**
   * Handle the dropdown event
   * @param {JQuery} $dropdown dropdown element
   */
  _dropdownEvent($dropdown) {
    let self = this;

    const $dropDownItem = $dropdown.next('.hide');

    let $navItem = $dropdown.closest('.navigation__item');
    const $parentNavItem = $navItem.parentsUntil($('.level-1')); //get the main navigation item for prevent closing it.
    const hasDropDown = $dropDownItem.length > 0;
    const $dropdownButton = $dropdown.find('button').first();

    if ($navItem.hasClass(openClass)) {
      $navItem = ''; //dropdown already open, so we close it
    }

    self._closeDropdown($('.navigation__item').not($parentNavItem, $navItem)); //reset all opened dropdowns except ones we don't want

    if (hasDropDown && $navItem.length) {
      self._toggleOpen($navItem, $($dropdownButton));
      self._toggleTabindex($navItem, $dropDownItem)
    }
  }

}

export default new NavigationHandler();
